import { useTheme } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

export interface FeeDuesComparisonChartProps {
  currentYearTotal: number;
  previousYearTotal: number;
  currentYearLabel: string;
  previousYearLabel: string;
}

// Same chart as FeeDuesComparisonBar, with one fix: the "previous year" bar
// used theme.palette.error.main (red), which visually reads as a bad/overdue
// status next to the real status chip. A comparison series isn't a status, so
// it gets a neutral gray here and red stays reserved for actual overdue state.
export const FeeDuesComparisonChart = ({
  currentYearTotal,
  previousYearTotal,
  currentYearLabel,
  previousYearLabel,
}: FeeDuesComparisonChartProps) => {
  const theme = useTheme();

  const formatIndianNumber = (num: number): string => {
    const absNum = Math.abs(num);
    if (absNum >= 1.0e7) return (num / 1.0e7).toFixed(1).replace(/\.0$/, "") + "Cr";
    if (absNum >= 1.0e5) return (num / 1.0e5).toFixed(1).replace(/\.0$/, "") + "L";
    if (absNum >= 1.0e3) return (num / 1.0e3).toFixed(1).replace(/\.0$/, "") + "K";
    return num.toString();
  };

  return (
    <BarChart
      xAxis={[{ scaleType: "band", data: [previousYearLabel, currentYearLabel] }]}
      yAxis={[{ valueFormatter: formatIndianNumber }]}
      series={[
        {
          data: [previousYearTotal, null],
          label: previousYearLabel,
          color: theme.palette.grey[500],
        },
        {
          data: [null, currentYearTotal],
          label: currentYearLabel,
          color: theme.palette.primary.main,
        },
      ]}
      height={180}
    />
  );
};
